/*
 *
 * Virtual Market
 * admin-api - Servicios
 *
 * SEKAISOFT 2020
 *
 */

/* Core Imports */
import axios from 'axios';
import { API_URL } from './config';

/* Dev Tools */
import { DEBUG } from 'common-protocols';
const OBJECT_ID = 'admin-api';

/*********************** Obtener Token Admin ***********************/
export function getTokenAdmin(body) {
    DEBUG && console.log(OBJECT_ID + "@getTokenAdmin: Petición del token Admin");

    let requestUrl = `${API_URL}/admin/login`;
    DEBUG && console.log(OBJECT_ID  + "@getTokenAdmin: requestUrl --> " + requestUrl);

    let request = {
        url: requestUrl,
        method: "post",
        data: body
    };

    return axios(request)
        .then(response=> ({ response }))
        .catch(error => ({ error }))
}

/*********************** Obtener Etiquetas para control ***********************/
export function requestLabels(token){
    DEBUG && console.log(OBJECT_ID + "@requestLabels: Petición etiquetas para control");

    let requestUrl = `${API_URL}/getEtiquetas`;
    DEBUG && console.log(OBJECT_ID  + "@requestLabels: requestUrl --> " + requestUrl);

    let request = {
        url: requestUrl,
        method: "get",
        headers: {'X-AUTH-TOKEN': token}
    };

    return axios(request)
        .then(response=> ({ response }))
        .catch(error => ({ error }))
}

export function requestToggleLabel({token, pkEtiqueta, activo}) {
    DEBUG && console.log(OBJECT_ID + "@requestLabels: Petición etiquetas para control");

    let requestUrl = `${API_URL}/etiquetas`;
    DEBUG && console.log(OBJECT_ID  + "@requestLabels: requestUrl --> " + requestUrl);

    const body = {
        pkEtiqueta,
        activo
    };

    let request = {
        url: requestUrl,
        method: "patch",
        data: body,
        headers: {'X-AUTH-TOKEN': token}
    };

    return axios(request)
        .then(response=> ({ response }))
        .catch(error => ({ error }))
}

/*********************** Obtener Cuestionarios para control ***********************/
export function requestQuestionnaires(token){
    DEBUG && console.log(OBJECT_ID + "@requestQuestionnaires: Petición cuestionarios para control");

    let requestUrl = `${API_URL}/getCuestionarios`;
    DEBUG && console.log(OBJECT_ID  + "@requestQuestionnaires: requestUrl --> " + requestUrl);

    let request = {
        url: requestUrl,
        method: "get",
        headers: {'X-AUTH-TOKEN': token}
    };

    return axios(request)
        .then(response=> ({ response }))
        .catch(error => ({ error }))
}

export function requestToggleQuestionnaire({token, pkCuestionario, activo}) {
    DEBUG && console.log(OBJECT_ID + "@requestQuestionnaires: Petición etiquetas para control");

    let requestUrl = `${API_URL}/cuestionarios`;
    DEBUG && console.log(OBJECT_ID  + "@requestQuestionnaires: requestUrl --> " + requestUrl);

    const body = {
        pkCuestionario,
        activo
    };

    let request = {
        url: requestUrl,
        method: "patch",
        data: body,
        headers: {'X-AUTH-TOKEN': token}
    };

    return axios(request)
        .then(response=> ({ response }))
        .catch(error => ({ error }))
}

export function requestRefreshSession(token) {
    DEBUG && console.log(OBJECT_ID + "@requestRefreshSession: Petición refrescar token");

    let requestUrl = `${API_URL}/admin/token`;
    DEBUG && console.log(OBJECT_ID  + "@requestRefreshSessions: requestUrl --> " + requestUrl);

    let request = {
        url: requestUrl,
        method: "put",
        headers: {'X-AUTH-TOKEN': token}
    };

    return axios(request)
        .then(response=> ({ response }))
        .catch(error => ({ error }))
}


// WEBPACK FOOTER //
// ./src/services/admin-api.js